"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CameraPreview = CameraPreview;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = require("styled-components");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _audioVideoHelpers = require("@studio/chime/audioVideo/audioVideoHelpers");
var _CameraPreview = require("./CameraPreview.styled");
var _BrandContext = _interopRequireDefault(require("../../contexts/BrandContext"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function CameraPreview(_ref) {
  var meetingSession = _ref.meetingSession,
    _ref$videoInputDevice = _ref.videoInputDevice,
    videoInputDevice = _ref$videoInputDevice === void 0 ? '' : _ref$videoInputDevice,
    _ref$videoNode = _ref.videoNode,
    videoNode = _ref$videoNode === void 0 ? null : _ref$videoNode,
    presenterTitle = _ref.presenterTitle,
    presenterDescription = _ref.presenterDescription,
    _ref$browserBlock = _ref.browserBlock,
    browserBlock = _ref$browserBlock === void 0 ? false : _ref$browserBlock,
    _ref$onVideoReady = _ref.onVideoReady,
    onVideoReady = _ref$onVideoReady === void 0 ? function () {} : _ref$onVideoReady;
  var videoElementRef = (0, _react.useRef)(null);
  var brandContext = (0, _react.useContext)(_BrandContext["default"]) || {};
  (0, _react.useEffect)(function () {
    var videoElement = videoElementRef.current;
    // Check if videoElement is defined and videoInputDevice is not empty
    // This is to prevent unnecessary initialization of the blur background
    if (!videoElement || videoInputDevice === '') return;
    var start = /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
        return _regenerator["default"].wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 1;
              return (0, _audioVideoHelpers.startVideoInput)(meetingSession, videoInputDevice);
            case 1:
              // Based on trial and error it was discovered that one must first choose a video device ID before starting preview (otherwise an error is yielded)
              (0, _audioVideoHelpers.startVideoPreviewForVideoInput)(meetingSession, videoElement);
              onVideoReady();
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function start() {
        return _ref2.apply(this, arguments);
      };
    }();
    start();
    return function () {
      /**
       * Initially we had an issue when stopping a preview for the video element. It had a cascading effect
       * where it stops the local video tile
       * see https://github.com/aws/amazon-chime-sdk-js/issues/502
       * Based on trial and error it was discovered that after stopping preview, one MUST choose a device again...
       * hence this workround solution
       * meetingSession.audioVideo.chooseVideoInputDevice(videoInputDevice);
       *
       * However, this issue https://github.com/aws/amazon-chime-sdk-js/issues/1818 explains the order for starting a local video tile
       * and implemented in director & presenter - https://github.com/SHOFLO/app.studio.director/pull/2330
       */
      (0, _audioVideoHelpers.stopVideoPreviewForVideoInput)(meetingSession, videoElement);
    };
  }, [videoElementRef, videoInputDevice]);
  var noInput = !videoInputDevice && !videoNode;
  var hasError = noInput || browserBlock;
  var errorMessage = browserBlock ? 'Allow your browser to access your devices to continue' : 'Select a working camera';
  var hasPresenterTitle = presenterTitle.trim() !== '';
  var hasPresenterDescription = presenterDescription.trim() !== '';
  var showNameCard = hasPresenterTitle || hasPresenterDescription;
  var videoElement = videoNode !== null && videoNode !== void 0 ? videoNode : /*#__PURE__*/_react["default"].createElement(_CameraPreview.StyledVideo, {
    "aria-label": "Camera Preview - title: ".concat(presenterTitle, " description: ").concat(presenterDescription),
    "data-testid": "video-element",
    ref: videoElementRef
  });
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: brandContext
  }, /*#__PURE__*/_react["default"].createElement(_CameraPreview.VideoWrapper, null, hasError ? /*#__PURE__*/_react["default"].createElement(_CameraPreview.StyledSection, {
    "data-testid": "error-element"
  }, /*#__PURE__*/_react["default"].createElement("span", null, errorMessage)) : videoElement, showNameCard && /*#__PURE__*/_react["default"].createElement(_CameraPreview.StyledNameCard, {
    "data-testid": "name-card",
    hasDescription: hasPresenterDescription
  }, /*#__PURE__*/_react["default"].createElement(_CameraPreview.StyledName, {
    className: "h6"
  }, presenterTitle), /*#__PURE__*/_react["default"].createElement(_CameraPreview.StyledDescription, null, presenterDescription))));
}
CameraPreview.propTypes = {
  meetingSession: _propTypes["default"].object.isRequired,
  videoInputDevice: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  videoNode: _propTypes["default"].node,
  presenterTitle: _propTypes["default"].string,
  presenterDescription: _propTypes["default"].string,
  browserBlock: _propTypes["default"].bool,
  onVideoReady: _propTypes["default"].func
};